import cx from 'classnames';
import type { FunctionComponent } from 'react';

type Props = {
  //  Which side the header should be "aligned" with. @default 'right'
  align?: 'right' | 'left';
};

/**
 * ListSidebarHeader is a variant of ListHeader which
 * allows either the right or left side to become "flush"
 * with the border next to it by removing the border-radius
 * which is usually applied to ListHeader.
 */
const ListSidebarHeader: FunctionComponent<Props> = ({ children, align = 'right' }) => (
  <header className={cx('fossa-list__header', {
    'fossa-list__header--sidebar-right': align === 'right',
    'fossa-list__header--sidebar-left': align === 'left',
  })}>
    {children}
  </header>
);

export default ListSidebarHeader;
